import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _69533530 = () => interopDefault(import('../pages/05th-agm-notice.vue' /* webpackChunkName: "pages/05th-agm-notice" */))
const _6c63c375 = () => interopDefault(import('../pages/1st-annual-general-meeting.vue' /* webpackChunkName: "pages/1st-annual-general-meeting" */))
const _2494207e = () => interopDefault(import('../pages/1st-extraordinary-general-meeting.vue' /* webpackChunkName: "pages/1st-extraordinary-general-meeting" */))
const _dd1efac2 = () => interopDefault(import('../pages/2nd-annual-general-meeting.vue' /* webpackChunkName: "pages/2nd-annual-general-meeting" */))
const _f51843d8 = () => interopDefault(import('../pages/2nd-extraordinary-general-meeting.vue' /* webpackChunkName: "pages/2nd-extraordinary-general-meeting" */))
const _6a189311 = () => interopDefault(import('../pages/3rd-extraordinary-general-meeting.vue' /* webpackChunkName: "pages/3rd-extraordinary-general-meeting" */))
const _01a1d654 = () => interopDefault(import('../pages/4th-extraordinary-general-meeting.vue' /* webpackChunkName: "pages/4th-extraordinary-general-meeting" */))
const _1549a9d5 = () => interopDefault(import('../pages/5th-extraordinary-general-meeting.vue' /* webpackChunkName: "pages/5th-extraordinary-general-meeting" */))
const _28f17d56 = () => interopDefault(import('../pages/6th-extraordinary-general-meeting.vue' /* webpackChunkName: "pages/6th-extraordinary-general-meeting" */))
const _21394730 = () => interopDefault(import('../pages/annual-return-mgt-7-2022.vue' /* webpackChunkName: "pages/annual-return-mgt-7-2022" */))
const _9c69bdfe = () => interopDefault(import('../pages/annual-return-mgt-7-fy-23.vue' /* webpackChunkName: "pages/annual-return-mgt-7-fy-23" */))
const _9c4d8efc = () => interopDefault(import('../pages/annual-return-mgt-7-fy-24.vue' /* webpackChunkName: "pages/annual-return-mgt-7-fy-24" */))
const _6c99ee40 = () => interopDefault(import('../pages/annual-return-MGT-9_2019.vue' /* webpackChunkName: "pages/annual-return-MGT-9_2019" */))
const _6a2de414 = () => interopDefault(import('../pages/annual-return-MGT-9_2020.vue' /* webpackChunkName: "pages/annual-return-MGT-9_2020" */))
const _372fcab2 = () => interopDefault(import('../pages/boards-report-2020.vue' /* webpackChunkName: "pages/boards-report-2020" */))
const _37139bb0 = () => interopDefault(import('../pages/boards-report-2021.vue' /* webpackChunkName: "pages/boards-report-2021" */))
const _36f76cae = () => interopDefault(import('../pages/boards-report-2022.vue' /* webpackChunkName: "pages/boards-report-2022" */))
const _36db3dac = () => interopDefault(import('../pages/boards-report-2023.vue' /* webpackChunkName: "pages/boards-report-2023" */))
const _36bf0eaa = () => interopDefault(import('../pages/boards-report-2024.vue' /* webpackChunkName: "pages/boards-report-2024" */))
const _b2814cbc = () => interopDefault(import('../pages/code-for-independent-directors.vue' /* webpackChunkName: "pages/code-for-independent-directors" */))
const _20e0054d = () => interopDefault(import('../pages/consolidated-financials-ksf-31-03-2024.vue' /* webpackChunkName: "pages/consolidated-financials-ksf-31-03-2024" */))
const _a3f67ac2 = () => interopDefault(import('../pages/contactUs/index.vue' /* webpackChunkName: "pages/contactUs/index" */))
const _4152ad5a = () => interopDefault(import('../pages/corporate-governance-policy.vue' /* webpackChunkName: "pages/corporate-governance-policy" */))
const _4d34950b = () => interopDefault(import('../pages/corporate-social-responsibility-policy.vue' /* webpackChunkName: "pages/corporate-social-responsibility-policy" */))
const _7906c63a = () => interopDefault(import('../pages/covid-resolution-framework/index.vue' /* webpackChunkName: "pages/covid-resolution-framework/index" */))
const _75a8c6c9 = () => interopDefault(import('../pages/csi-app-privacy-policy.vue' /* webpackChunkName: "pages/csi-app-privacy-policy" */))
const _88a779b4 = () => interopDefault(import('../pages/csi-app-terms-and-conditions.vue' /* webpackChunkName: "pages/csi-app-terms-and-conditions" */))
const _ac5527b8 = () => interopDefault(import('../pages/csr-annual-action-plan-fy-2024-25.vue' /* webpackChunkName: "pages/csr-annual-action-plan-fy-2024-25" */))
const _7562e4ac = () => interopDefault(import('../pages/customer-awareness-on-sma-and-npa-classification/index.vue' /* webpackChunkName: "pages/customer-awareness-on-sma-and-npa-classification/index" */))
const _7f882480 = () => interopDefault(import('../pages/equal-opportunity-and-anti-discrimination-policy.vue' /* webpackChunkName: "pages/equal-opportunity-and-anti-discrimination-policy" */))
const _1201f1cd = () => interopDefault(import('../pages/ex-gratia-interest-relief-scheme.vue' /* webpackChunkName: "pages/ex-gratia-interest-relief-scheme" */))
const _1723cebf = () => interopDefault(import('../pages/fair-practice-code-assamese.vue' /* webpackChunkName: "pages/fair-practice-code-assamese" */))
const _70a0a8c6 = () => interopDefault(import('../pages/fair-practice-code-bengali.vue' /* webpackChunkName: "pages/fair-practice-code-bengali" */))
const _0e3c445e = () => interopDefault(import('../pages/fair-practice-code-gujarati.vue' /* webpackChunkName: "pages/fair-practice-code-gujarati" */))
const _a519f366 = () => interopDefault(import('../pages/fair-practice-code-hindi.vue' /* webpackChunkName: "pages/fair-practice-code-hindi" */))
const _08b62dfa = () => interopDefault(import('../pages/fair-practice-code-kannada.vue' /* webpackChunkName: "pages/fair-practice-code-kannada" */))
const _3ca466a2 = () => interopDefault(import('../pages/fair-practice-code-malayalam.vue' /* webpackChunkName: "pages/fair-practice-code-malayalam" */))
const _246b478d = () => interopDefault(import('../pages/fair-practice-code-marathi.vue' /* webpackChunkName: "pages/fair-practice-code-marathi" */))
const _625be092 = () => interopDefault(import('../pages/fair-practice-code-odiya.vue' /* webpackChunkName: "pages/fair-practice-code-odiya" */))
const _356b19be = () => interopDefault(import('../pages/fair-practice-code-tamil.vue' /* webpackChunkName: "pages/fair-practice-code-tamil" */))
const _5199ed86 = () => interopDefault(import('../pages/fair-practice-code-telugu.vue' /* webpackChunkName: "pages/fair-practice-code-telugu" */))
const _f2445c68 = () => interopDefault(import('../pages/fair-practices-code/index.vue' /* webpackChunkName: "pages/fair-practices-code/index" */))
const _ac71d3de = () => interopDefault(import('../pages/financials-ksf-31-03-2019.vue' /* webpackChunkName: "pages/financials-ksf-31-03-2019" */))
const _aa05c9b2 = () => interopDefault(import('../pages/financials-ksf-31-03-2020.vue' /* webpackChunkName: "pages/financials-ksf-31-03-2020" */))
const _a9e99ab0 = () => interopDefault(import('../pages/financials-ksf-31-03-2021.vue' /* webpackChunkName: "pages/financials-ksf-31-03-2021" */))
const _a9cd6bae = () => interopDefault(import('../pages/financials-ksf-31-03-2022.vue' /* webpackChunkName: "pages/financials-ksf-31-03-2022" */))
const _a9b13cac = () => interopDefault(import('../pages/financials-ksf-31-03-2023.vue' /* webpackChunkName: "pages/financials-ksf-31-03-2023" */))
const _a9950daa = () => interopDefault(import('../pages/financials-ksf-31-03-2024.vue' /* webpackChunkName: "pages/financials-ksf-31-03-2024" */))
const _4be0b5cd = () => interopDefault(import('../pages/form-mgt-7-2021.vue' /* webpackChunkName: "pages/form-mgt-7-2021" */))
const _79db6ab4 = () => interopDefault(import('../pages/grievance-redressal-policy/index.vue' /* webpackChunkName: "pages/grievance-redressal-policy/index" */))
const _5298e7f6 = () => interopDefault(import('../pages/grievance-redressal-policy-assamese.vue' /* webpackChunkName: "pages/grievance-redressal-policy-assamese" */))
const _09b1e0f4 = () => interopDefault(import('../pages/grievance-redressal-policy-bengali.vue' /* webpackChunkName: "pages/grievance-redressal-policy-bengali" */))
const _49b15d95 = () => interopDefault(import('../pages/grievance-redressal-policy-gujarati.vue' /* webpackChunkName: "pages/grievance-redressal-policy-gujarati" */))
const _04145076 = () => interopDefault(import('../pages/grievance-redressal-policy-hindi.vue' /* webpackChunkName: "pages/grievance-redressal-policy-hindi" */))
const _2f1c4cec = () => interopDefault(import('../pages/grievance-redressal-policy-kannada.vue' /* webpackChunkName: "pages/grievance-redressal-policy-kannada" */))
const _6fd2744b = () => interopDefault(import('../pages/grievance-redressal-policy-malayalam.vue' /* webpackChunkName: "pages/grievance-redressal-policy-malayalam" */))
const _57e2ab76 = () => interopDefault(import('../pages/grievance-redressal-policy-marathi.vue' /* webpackChunkName: "pages/grievance-redressal-policy-marathi" */))
const _257359e0 = () => interopDefault(import('../pages/grievance-redressal-policy-odiya.vue' /* webpackChunkName: "pages/grievance-redressal-policy-odiya" */))
const _e7e73832 = () => interopDefault(import('../pages/grievance-redressal-policy-tamil.vue' /* webpackChunkName: "pages/grievance-redressal-policy-tamil" */))
const _54bb0434 = () => interopDefault(import('../pages/grievance-redressal-policy-telugu.vue' /* webpackChunkName: "pages/grievance-redressal-policy-telugu" */))
const _3f87e2be = () => interopDefault(import('../pages/group-safeguard-insurance-policy-wordings.vue' /* webpackChunkName: "pages/group-safeguard-insurance-policy-wordings" */))
const _dd341d20 = () => interopDefault(import('../pages/icici-lombard-annexure.vue' /* webpackChunkName: "pages/icici-lombard-annexure" */))
const _32937d9f = () => interopDefault(import('../pages/icici-lombard-terms-and-conditons.vue' /* webpackChunkName: "pages/icici-lombard-terms-and-conditons" */))
const _e6ac8248 = () => interopDefault(import('../pages/income-protect-and-gsg-terms-and-conditions.vue' /* webpackChunkName: "pages/income-protect-and-gsg-terms-and-conditions" */))
const _3bf8afa6 = () => interopDefault(import('../pages/income-protect-policy-wordings.vue' /* webpackChunkName: "pages/income-protect-policy-wordings" */))
const _144df79b = () => interopDefault(import('../pages/insurance/index.vue' /* webpackChunkName: "pages/insurance/index" */))
const _387c121a = () => interopDefault(import('../pages/integrated-ombudsman-scheme/index.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme/index" */))
const _16b37f57 = () => interopDefault(import('../pages/integrated-ombudsman-scheme-assamese.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-assamese" */))
const _f4c8eff6 = () => interopDefault(import('../pages/integrated-ombudsman-scheme-bengali.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-bengali" */))
const _0dcbf4f6 = () => interopDefault(import('../pages/integrated-ombudsman-scheme-gujarati.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-gujarati" */))
const _6dfadcb5 = () => interopDefault(import('../pages/integrated-ombudsman-scheme-hindi.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-hindi" */))
const _8cde752a = () => interopDefault(import('../pages/integrated-ombudsman-scheme-kannada.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-kannada" */))
const _2f0ac90a = () => interopDefault(import('../pages/integrated-ombudsman-scheme-malayalam.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-malayalam" */))
const _3b51b816 = () => interopDefault(import('../pages/integrated-ombudsman-scheme-marathi.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-marathi" */))
const _e14c33c2 = () => interopDefault(import('../pages/integrated-ombudsman-scheme-odiya.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-odiya" */))
const _141a1fb4 = () => interopDefault(import('../pages/integrated-ombudsman-scheme-tamil.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-tamil" */))
const _27a5ffd5 = () => interopDefault(import('../pages/integrated-ombudsman-scheme-telugu.vue' /* webpackChunkName: "pages/integrated-ombudsman-scheme-telugu" */))
const _6207825e = () => interopDefault(import('../pages/interest-rate-policy/index.vue' /* webpackChunkName: "pages/interest-rate-policy/index" */))
const _4edb4cd8 = () => interopDefault(import('../pages/ksf-annual-report-2023-24.vue' /* webpackChunkName: "pages/ksf-annual-report-2023-24" */))
const _397d5f8a = () => interopDefault(import('../pages/ksf-public-disclosure-on-liquidity-risk-dec-2022.vue' /* webpackChunkName: "pages/ksf-public-disclosure-on-liquidity-risk-dec-2022" */))
const _2481cb70 = () => interopDefault(import('../pages/ksf-public-disclosure-on-liquidity-risk-june-2023.vue' /* webpackChunkName: "pages/ksf-public-disclosure-on-liquidity-risk-june-2023" */))
const _24659c6e = () => interopDefault(import('../pages/ksf-public-disclosure-on-liquidity-risk-june-2024.vue' /* webpackChunkName: "pages/ksf-public-disclosure-on-liquidity-risk-june-2024" */))
const _e2ebf8c8 = () => interopDefault(import('../pages/ksf-public-disclosure-on-liquidity-risk-march-2024.vue' /* webpackChunkName: "pages/ksf-public-disclosure-on-liquidity-risk-march-2024" */))
const _3ae3e76e = () => interopDefault(import('../pages/nach-mandate-cancellation-form/index.vue' /* webpackChunkName: "pages/nach-mandate-cancellation-form/index" */))
const _1025f17d = () => interopDefault(import('../pages/nomination-and-renumeration-policy.vue' /* webpackChunkName: "pages/nomination-and-renumeration-policy" */))
const _10f9a625 = () => interopDefault(import('../pages/notice-of-04th-agm.vue' /* webpackChunkName: "pages/notice-of-04th-agm" */))
const _b97ea928 = () => interopDefault(import('../pages/notice-of-07th-egm.vue' /* webpackChunkName: "pages/notice-of-07th-egm" */))
const _38255e2d = () => interopDefault(import('../pages/notice-of-08th-egm.vue' /* webpackChunkName: "pages/notice-of-08th-egm" */))
const _3ca9ad10 = () => interopDefault(import('../pages/operational-guidelines.vue' /* webpackChunkName: "pages/operational-guidelines" */))
const _215a3dde = () => interopDefault(import('../pages/pocket-insurance-policy-wordings.vue' /* webpackChunkName: "pages/pocket-insurance-policy-wordings" */))
const _81e42248 = () => interopDefault(import('../pages/pocket-insurance-terms-and-conditions.vue' /* webpackChunkName: "pages/pocket-insurance-terms-and-conditions" */))
const _0a5acb7a = () => interopDefault(import('../pages/policy-for-appointment-of-statutory-auditors.vue' /* webpackChunkName: "pages/policy-for-appointment-of-statutory-auditors" */))
const _20124f0c = () => interopDefault(import('../pages/privacy-policy/index.vue' /* webpackChunkName: "pages/privacy-policy/index" */))
const _fdbd5e44 = () => interopDefault(import('../pages/privacy-policy-of-privo.vue' /* webpackChunkName: "pages/privacy-policy-of-privo" */))
const _388f1380 = () => interopDefault(import('../pages/privo-terms-conditions/index.vue' /* webpackChunkName: "pages/privo-terms-conditions/index" */))
const _1bec4b58 = () => interopDefault(import('../pages/public-disclosure-on-liquidity-risk-december-2023.vue' /* webpackChunkName: "pages/public-disclosure-on-liquidity-risk-december-2023" */))
const _41bf09f6 = () => interopDefault(import('../pages/public-Disclosure-on-liquidity-risk-june-2022.vue' /* webpackChunkName: "pages/public-Disclosure-on-liquidity-risk-june-2022" */))
const _87be996a = () => interopDefault(import('../pages/public-Disclosure-on-liquidity-risk-march-2022.vue' /* webpackChunkName: "pages/public-Disclosure-on-liquidity-risk-march-2022" */))
const _645ca2ec = () => interopDefault(import('../pages/public-disclosure-on-liquidity-risk-march-2023.vue' /* webpackChunkName: "pages/public-disclosure-on-liquidity-risk-march-2023" */))
const _84e93a06 = () => interopDefault(import('../pages/public-Disclosure-on-liquidity-risk-september-2022.vue' /* webpackChunkName: "pages/public-Disclosure-on-liquidity-risk-september-2022" */))
const _6cde429e = () => interopDefault(import('../pages/public-disclosure-on-liquidity-risk-september-2023.vue' /* webpackChunkName: "pages/public-disclosure-on-liquidity-risk-september-2023" */))
const _6cec5a1f = () => interopDefault(import('../pages/public-disclosure-on-liquidity-risk-september-2024.vue' /* webpackChunkName: "pages/public-disclosure-on-liquidity-risk-september-2024" */))
const _27b3ccf6 = () => interopDefault(import('../pages/rbi-integrated-ombudsman-scheme-nov-2021.vue' /* webpackChunkName: "pages/rbi-integrated-ombudsman-scheme-nov-2021" */))
const _45cc1e4d = () => interopDefault(import('../pages/regulatory/index.vue' /* webpackChunkName: "pages/regulatory/index" */))
const _7a03b648 = () => interopDefault(import('../pages/related-party-transaction-policy.vue' /* webpackChunkName: "pages/related-party-transaction-policy" */))
const _1b44f2f6 = () => interopDefault(import('../pages/resignation-letter-of-akihiro-matsuda.vue' /* webpackChunkName: "pages/resignation-letter-of-akihiro-matsuda" */))
const _31260803 = () => interopDefault(import('../pages/resignation-letter-of-amit-dutta.vue' /* webpackChunkName: "pages/resignation-letter-of-amit-dutta" */))
const _31a4da00 = () => interopDefault(import('../pages/resignation-letter-of-jitendra-gupta.vue' /* webpackChunkName: "pages/resignation-letter-of-jitendra-gupta" */))
const _0bd2c922 = () => interopDefault(import('../pages/resignation-letter-of-osamu-sugita.vue' /* webpackChunkName: "pages/resignation-letter-of-osamu-sugita" */))
const _49fd654a = () => interopDefault(import('../pages/resignation-letter-of-ravi-neeladri.vue' /* webpackChunkName: "pages/resignation-letter-of-ravi-neeladri" */))
const _e80b4cf8 = () => interopDefault(import('../pages/resignation-letter-of-sanjeev-sharma.vue' /* webpackChunkName: "pages/resignation-letter-of-sanjeev-sharma" */))
const _2224f6b0 = () => interopDefault(import('../pages/resignation-letter-of-yasuyuki-isobe.vue' /* webpackChunkName: "pages/resignation-letter-of-yasuyuki-isobe" */))
const _00a100b8 = () => interopDefault(import('../pages/statutory/index.vue' /* webpackChunkName: "pages/statutory/index" */))
const _722eb773 = () => interopDefault(import('../pages/terms-conditions/index.vue' /* webpackChunkName: "pages/terms-conditions/index" */))
const _80b21f66 = () => interopDefault(import('../pages/third_general_meeting/index.vue' /* webpackChunkName: "pages/third_general_meeting/index" */))
const _25813e00 = () => interopDefault(import('../pages/whistleblower-policy.vue' /* webpackChunkName: "pages/whistleblower-policy" */))
const _740ba7e0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/05th-agm-notice",
    component: _69533530,
    name: "05th-agm-notice"
  }, {
    path: "/1st-annual-general-meeting",
    component: _6c63c375,
    name: "1st-annual-general-meeting"
  }, {
    path: "/1st-extraordinary-general-meeting",
    component: _2494207e,
    name: "1st-extraordinary-general-meeting"
  }, {
    path: "/2nd-annual-general-meeting",
    component: _dd1efac2,
    name: "2nd-annual-general-meeting"
  }, {
    path: "/2nd-extraordinary-general-meeting",
    component: _f51843d8,
    name: "2nd-extraordinary-general-meeting"
  }, {
    path: "/3rd-extraordinary-general-meeting",
    component: _6a189311,
    name: "3rd-extraordinary-general-meeting"
  }, {
    path: "/4th-extraordinary-general-meeting",
    component: _01a1d654,
    name: "4th-extraordinary-general-meeting"
  }, {
    path: "/5th-extraordinary-general-meeting",
    component: _1549a9d5,
    name: "5th-extraordinary-general-meeting"
  }, {
    path: "/6th-extraordinary-general-meeting",
    component: _28f17d56,
    name: "6th-extraordinary-general-meeting"
  }, {
    path: "/annual-return-mgt-7-2022",
    component: _21394730,
    name: "annual-return-mgt-7-2022"
  }, {
    path: "/annual-return-mgt-7-fy-23",
    component: _9c69bdfe,
    name: "annual-return-mgt-7-fy-23"
  }, {
    path: "/annual-return-mgt-7-fy-24",
    component: _9c4d8efc,
    name: "annual-return-mgt-7-fy-24"
  }, {
    path: "/annual-return-MGT-9_2019",
    component: _6c99ee40,
    name: "annual-return-MGT-9_2019"
  }, {
    path: "/annual-return-MGT-9_2020",
    component: _6a2de414,
    name: "annual-return-MGT-9_2020"
  }, {
    path: "/boards-report-2020",
    component: _372fcab2,
    name: "boards-report-2020"
  }, {
    path: "/boards-report-2021",
    component: _37139bb0,
    name: "boards-report-2021"
  }, {
    path: "/boards-report-2022",
    component: _36f76cae,
    name: "boards-report-2022"
  }, {
    path: "/boards-report-2023",
    component: _36db3dac,
    name: "boards-report-2023"
  }, {
    path: "/boards-report-2024",
    component: _36bf0eaa,
    name: "boards-report-2024"
  }, {
    path: "/code-for-independent-directors",
    component: _b2814cbc,
    name: "code-for-independent-directors"
  }, {
    path: "/consolidated-financials-ksf-31-03-2024",
    component: _20e0054d,
    name: "consolidated-financials-ksf-31-03-2024"
  }, {
    path: "/contactUs",
    component: _a3f67ac2,
    name: "contactUs"
  }, {
    path: "/corporate-governance-policy",
    component: _4152ad5a,
    name: "corporate-governance-policy"
  }, {
    path: "/corporate-social-responsibility-policy",
    component: _4d34950b,
    name: "corporate-social-responsibility-policy"
  }, {
    path: "/covid-resolution-framework",
    component: _7906c63a,
    name: "covid-resolution-framework"
  }, {
    path: "/csi-app-privacy-policy",
    component: _75a8c6c9,
    name: "csi-app-privacy-policy"
  }, {
    path: "/csi-app-terms-and-conditions",
    component: _88a779b4,
    name: "csi-app-terms-and-conditions"
  }, {
    path: "/csr-annual-action-plan-fy-2024-25",
    component: _ac5527b8,
    name: "csr-annual-action-plan-fy-2024-25"
  }, {
    path: "/customer-awareness-on-sma-and-npa-classification",
    component: _7562e4ac,
    name: "customer-awareness-on-sma-and-npa-classification"
  }, {
    path: "/equal-opportunity-and-anti-discrimination-policy",
    component: _7f882480,
    name: "equal-opportunity-and-anti-discrimination-policy"
  }, {
    path: "/ex-gratia-interest-relief-scheme",
    component: _1201f1cd,
    name: "ex-gratia-interest-relief-scheme"
  }, {
    path: "/fair-practice-code-assamese",
    component: _1723cebf,
    name: "fair-practice-code-assamese"
  }, {
    path: "/fair-practice-code-bengali",
    component: _70a0a8c6,
    name: "fair-practice-code-bengali"
  }, {
    path: "/fair-practice-code-gujarati",
    component: _0e3c445e,
    name: "fair-practice-code-gujarati"
  }, {
    path: "/fair-practice-code-hindi",
    component: _a519f366,
    name: "fair-practice-code-hindi"
  }, {
    path: "/fair-practice-code-kannada",
    component: _08b62dfa,
    name: "fair-practice-code-kannada"
  }, {
    path: "/fair-practice-code-malayalam",
    component: _3ca466a2,
    name: "fair-practice-code-malayalam"
  }, {
    path: "/fair-practice-code-marathi",
    component: _246b478d,
    name: "fair-practice-code-marathi"
  }, {
    path: "/fair-practice-code-odiya",
    component: _625be092,
    name: "fair-practice-code-odiya"
  }, {
    path: "/fair-practice-code-tamil",
    component: _356b19be,
    name: "fair-practice-code-tamil"
  }, {
    path: "/fair-practice-code-telugu",
    component: _5199ed86,
    name: "fair-practice-code-telugu"
  }, {
    path: "/fair-practices-code",
    component: _f2445c68,
    name: "fair-practices-code"
  }, {
    path: "/financials-ksf-31-03-2019",
    component: _ac71d3de,
    name: "financials-ksf-31-03-2019"
  }, {
    path: "/financials-ksf-31-03-2020",
    component: _aa05c9b2,
    name: "financials-ksf-31-03-2020"
  }, {
    path: "/financials-ksf-31-03-2021",
    component: _a9e99ab0,
    name: "financials-ksf-31-03-2021"
  }, {
    path: "/financials-ksf-31-03-2022",
    component: _a9cd6bae,
    name: "financials-ksf-31-03-2022"
  }, {
    path: "/financials-ksf-31-03-2023",
    component: _a9b13cac,
    name: "financials-ksf-31-03-2023"
  }, {
    path: "/financials-ksf-31-03-2024",
    component: _a9950daa,
    name: "financials-ksf-31-03-2024"
  }, {
    path: "/form-mgt-7-2021",
    component: _4be0b5cd,
    name: "form-mgt-7-2021"
  }, {
    path: "/grievance-redressal-policy",
    component: _79db6ab4,
    name: "grievance-redressal-policy"
  }, {
    path: "/grievance-redressal-policy-assamese",
    component: _5298e7f6,
    name: "grievance-redressal-policy-assamese"
  }, {
    path: "/grievance-redressal-policy-bengali",
    component: _09b1e0f4,
    name: "grievance-redressal-policy-bengali"
  }, {
    path: "/grievance-redressal-policy-gujarati",
    component: _49b15d95,
    name: "grievance-redressal-policy-gujarati"
  }, {
    path: "/grievance-redressal-policy-hindi",
    component: _04145076,
    name: "grievance-redressal-policy-hindi"
  }, {
    path: "/grievance-redressal-policy-kannada",
    component: _2f1c4cec,
    name: "grievance-redressal-policy-kannada"
  }, {
    path: "/grievance-redressal-policy-malayalam",
    component: _6fd2744b,
    name: "grievance-redressal-policy-malayalam"
  }, {
    path: "/grievance-redressal-policy-marathi",
    component: _57e2ab76,
    name: "grievance-redressal-policy-marathi"
  }, {
    path: "/grievance-redressal-policy-odiya",
    component: _257359e0,
    name: "grievance-redressal-policy-odiya"
  }, {
    path: "/grievance-redressal-policy-tamil",
    component: _e7e73832,
    name: "grievance-redressal-policy-tamil"
  }, {
    path: "/grievance-redressal-policy-telugu",
    component: _54bb0434,
    name: "grievance-redressal-policy-telugu"
  }, {
    path: "/group-safeguard-insurance-policy-wordings",
    component: _3f87e2be,
    name: "group-safeguard-insurance-policy-wordings"
  }, {
    path: "/icici-lombard-annexure",
    component: _dd341d20,
    name: "icici-lombard-annexure"
  }, {
    path: "/icici-lombard-terms-and-conditons",
    component: _32937d9f,
    name: "icici-lombard-terms-and-conditons"
  }, {
    path: "/income-protect-and-gsg-terms-and-conditions",
    component: _e6ac8248,
    name: "income-protect-and-gsg-terms-and-conditions"
  }, {
    path: "/income-protect-policy-wordings",
    component: _3bf8afa6,
    name: "income-protect-policy-wordings"
  }, {
    path: "/insurance",
    component: _144df79b,
    name: "insurance"
  }, {
    path: "/integrated-ombudsman-scheme",
    component: _387c121a,
    name: "integrated-ombudsman-scheme"
  }, {
    path: "/integrated-ombudsman-scheme-assamese",
    component: _16b37f57,
    name: "integrated-ombudsman-scheme-assamese"
  }, {
    path: "/integrated-ombudsman-scheme-bengali",
    component: _f4c8eff6,
    name: "integrated-ombudsman-scheme-bengali"
  }, {
    path: "/integrated-ombudsman-scheme-gujarati",
    component: _0dcbf4f6,
    name: "integrated-ombudsman-scheme-gujarati"
  }, {
    path: "/integrated-ombudsman-scheme-hindi",
    component: _6dfadcb5,
    name: "integrated-ombudsman-scheme-hindi"
  }, {
    path: "/integrated-ombudsman-scheme-kannada",
    component: _8cde752a,
    name: "integrated-ombudsman-scheme-kannada"
  }, {
    path: "/integrated-ombudsman-scheme-malayalam",
    component: _2f0ac90a,
    name: "integrated-ombudsman-scheme-malayalam"
  }, {
    path: "/integrated-ombudsman-scheme-marathi",
    component: _3b51b816,
    name: "integrated-ombudsman-scheme-marathi"
  }, {
    path: "/integrated-ombudsman-scheme-odiya",
    component: _e14c33c2,
    name: "integrated-ombudsman-scheme-odiya"
  }, {
    path: "/integrated-ombudsman-scheme-tamil",
    component: _141a1fb4,
    name: "integrated-ombudsman-scheme-tamil"
  }, {
    path: "/integrated-ombudsman-scheme-telugu",
    component: _27a5ffd5,
    name: "integrated-ombudsman-scheme-telugu"
  }, {
    path: "/interest-rate-policy",
    component: _6207825e,
    name: "interest-rate-policy"
  }, {
    path: "/ksf-annual-report-2023-24",
    component: _4edb4cd8,
    name: "ksf-annual-report-2023-24"
  }, {
    path: "/ksf-public-disclosure-on-liquidity-risk-dec-2022",
    component: _397d5f8a,
    name: "ksf-public-disclosure-on-liquidity-risk-dec-2022"
  }, {
    path: "/ksf-public-disclosure-on-liquidity-risk-june-2023",
    component: _2481cb70,
    name: "ksf-public-disclosure-on-liquidity-risk-june-2023"
  }, {
    path: "/ksf-public-disclosure-on-liquidity-risk-june-2024",
    component: _24659c6e,
    name: "ksf-public-disclosure-on-liquidity-risk-june-2024"
  }, {
    path: "/ksf-public-disclosure-on-liquidity-risk-march-2024",
    component: _e2ebf8c8,
    name: "ksf-public-disclosure-on-liquidity-risk-march-2024"
  }, {
    path: "/nach-mandate-cancellation-form",
    component: _3ae3e76e,
    name: "nach-mandate-cancellation-form"
  }, {
    path: "/nomination-and-renumeration-policy",
    component: _1025f17d,
    name: "nomination-and-renumeration-policy"
  }, {
    path: "/notice-of-04th-agm",
    component: _10f9a625,
    name: "notice-of-04th-agm"
  }, {
    path: "/notice-of-07th-egm",
    component: _b97ea928,
    name: "notice-of-07th-egm"
  }, {
    path: "/notice-of-08th-egm",
    component: _38255e2d,
    name: "notice-of-08th-egm"
  }, {
    path: "/operational-guidelines",
    component: _3ca9ad10,
    name: "operational-guidelines"
  }, {
    path: "/pocket-insurance-policy-wordings",
    component: _215a3dde,
    name: "pocket-insurance-policy-wordings"
  }, {
    path: "/pocket-insurance-terms-and-conditions",
    component: _81e42248,
    name: "pocket-insurance-terms-and-conditions"
  }, {
    path: "/policy-for-appointment-of-statutory-auditors",
    component: _0a5acb7a,
    name: "policy-for-appointment-of-statutory-auditors"
  }, {
    path: "/privacy-policy",
    component: _20124f0c,
    name: "privacy-policy"
  }, {
    path: "/privacy-policy-of-privo",
    component: _fdbd5e44,
    name: "privacy-policy-of-privo"
  }, {
    path: "/privo-terms-conditions",
    component: _388f1380,
    name: "privo-terms-conditions"
  }, {
    path: "/public-disclosure-on-liquidity-risk-december-2023",
    component: _1bec4b58,
    name: "public-disclosure-on-liquidity-risk-december-2023"
  }, {
    path: "/public-Disclosure-on-liquidity-risk-june-2022",
    component: _41bf09f6,
    name: "public-Disclosure-on-liquidity-risk-june-2022"
  }, {
    path: "/public-Disclosure-on-liquidity-risk-march-2022",
    component: _87be996a,
    name: "public-Disclosure-on-liquidity-risk-march-2022"
  }, {
    path: "/public-disclosure-on-liquidity-risk-march-2023",
    component: _645ca2ec,
    name: "public-disclosure-on-liquidity-risk-march-2023"
  }, {
    path: "/public-Disclosure-on-liquidity-risk-september-2022",
    component: _84e93a06,
    name: "public-Disclosure-on-liquidity-risk-september-2022"
  }, {
    path: "/public-disclosure-on-liquidity-risk-september-2023",
    component: _6cde429e,
    name: "public-disclosure-on-liquidity-risk-september-2023"
  }, {
    path: "/public-disclosure-on-liquidity-risk-september-2024",
    component: _6cec5a1f,
    name: "public-disclosure-on-liquidity-risk-september-2024"
  }, {
    path: "/rbi-integrated-ombudsman-scheme-nov-2021",
    component: _27b3ccf6,
    name: "rbi-integrated-ombudsman-scheme-nov-2021"
  }, {
    path: "/regulatory",
    component: _45cc1e4d,
    name: "regulatory"
  }, {
    path: "/related-party-transaction-policy",
    component: _7a03b648,
    name: "related-party-transaction-policy"
  }, {
    path: "/resignation-letter-of-akihiro-matsuda",
    component: _1b44f2f6,
    name: "resignation-letter-of-akihiro-matsuda"
  }, {
    path: "/resignation-letter-of-amit-dutta",
    component: _31260803,
    name: "resignation-letter-of-amit-dutta"
  }, {
    path: "/resignation-letter-of-jitendra-gupta",
    component: _31a4da00,
    name: "resignation-letter-of-jitendra-gupta"
  }, {
    path: "/resignation-letter-of-osamu-sugita",
    component: _0bd2c922,
    name: "resignation-letter-of-osamu-sugita"
  }, {
    path: "/resignation-letter-of-ravi-neeladri",
    component: _49fd654a,
    name: "resignation-letter-of-ravi-neeladri"
  }, {
    path: "/resignation-letter-of-sanjeev-sharma",
    component: _e80b4cf8,
    name: "resignation-letter-of-sanjeev-sharma"
  }, {
    path: "/resignation-letter-of-yasuyuki-isobe",
    component: _2224f6b0,
    name: "resignation-letter-of-yasuyuki-isobe"
  }, {
    path: "/statutory",
    component: _00a100b8,
    name: "statutory"
  }, {
    path: "/terms-conditions",
    component: _722eb773,
    name: "terms-conditions"
  }, {
    path: "/third_general_meeting",
    component: _80b21f66,
    name: "third_general_meeting"
  }, {
    path: "/whistleblower-policy",
    component: _25813e00,
    name: "whistleblower-policy"
  }, {
    path: "/",
    component: _740ba7e0,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
